export default __webpack_public_path__ + "images/0d4448bd061a5cd5fc38d0a651cf32cd.png";